import React, { forwardRef, useEffect, useRef, useState, } from 'react';
import { FormFieldControl, Button, Base, FormTextarea, FormInput, } from '@stepstone-genesis/components';
import { useActiveBreakpointValue } from '@stepstone-genesis/hooks';
import { ArrowUpIcon } from '@stepstone-genesis/icons';
import labels from 'modules/hub/components/AMAChat/constants/labels/ama';
import Autocomplete from './Autocomplete';
const Input = forwardRef(({ lang, disabled, suggestions = [], placeholder, onSubmit, onChange, onToggleAutocomplete, amaConversationID, messageCount, }, ref) => {
    const [inputValue, setInputValue] = useState('');
    const [inputPopulated, setInputPopulated] = useState(false);
    const formRef = useRef(null);
    const isMobile = useActiveBreakpointValue([true, false]);
    useEffect(() => {
        if (onChange)
            onChange(inputValue);
    }, [inputValue]);
    useEffect(() => {
        const handler = setTimeout(() => {
            setInputPopulated(inputValue && inputValue.trim().length > 0 ? true : false);
        }, 500);
        return () => {
            clearTimeout(handler);
        };
    }, [inputValue]);
    const handleSubmitQuestion = (inputValue, e) => {
        e.preventDefault();
        if (!inputValue)
            return;
        onSubmit(inputValue);
        // storeUserQuestion(inputValue);
        setInputValue('');
    };
    const resolvedAmaConversationID = amaConversationID || 'noValue';
    const textBoxClickPayload = JSON.stringify({
        linkName: 'textBoxClick',
        componentState: 'conversationStarted',
        elementActioned: 'textBox',
        elementAction: 'click',
        elementActionValue: 'noValue',
        amaConversationID: resolvedAmaConversationID,
    });
    const questionSubmitPayload = JSON.stringify({
        linkName: 'questionSubmitted',
        componentState: 'conversationStarted',
        elementActioned: 'question',
        elementAction: 'submitted',
        elementActionValue: messageCount != null ? `message${messageCount + 1}` : 'noValue', // loose != catches null and undefined
        amaConversationID: resolvedAmaConversationID,
    });
    return (React.createElement("form", { ref: formRef, onSubmit: (event) => handleSubmitQuestion(inputValue, event), "data-testid": "question-form", "data-atx-onsubmit-payload": questionSubmitPayload },
        React.createElement(FormFieldControl, { sx: {
                "[data-genesis-element='BASE']": {
                    borderRadius: '16px',
                },
            } }, suggestions.length ? (React.createElement("div", { "data-atx-onclick-payload": textBoxClickPayload },
            React.createElement(Autocomplete, { items: suggestions, onChange: setInputValue, onToggle: (val) => {
                    if (onToggleAutocomplete)
                        onToggleAutocomplete(val);
                }, clearInput: inputValue === '' }))) : isMobile ? (React.createElement(Base, { sx: {
                paddingX: 'spaceS',
            } },
            React.createElement(FormInput, { ref: null, disabled: disabled, placeholder: placeholder || labels[lang].entrypointInputPlaceholder, autoComplete: "off", value: inputValue, "data-atx-onclick-payload": textBoxClickPayload, maxLength: 1500, onChange: (e) => setInputValue(e.target.value), onKeyUp: (e) => {
                    if (!e || !inputValue.trim().length)
                        return;
                    if (e.key === 'Enter') {
                        formRef.current?.requestSubmit();
                    }
                }, 
                // FormInput size="medium" (default) uses fontSizeM = 16px, which
                // prevents iOS Safari from auto-zooming on focus (threshold is 16px).
                sx: {
                    borderColor: 'colorBorderForm',
                    _focusWithin: {
                        borderColor: 'colorBorderActionable',
                    },
                }, inputContainerGroupStyles: { borderRadius: 'radiusXl' }, suffix: React.createElement(Button, { a11yLabel: labels[lang].submitQuestion, variant: "primary", size: "small", iconOnly: React.createElement(ArrowUpIcon, null), type: "submit", disabled: !inputPopulated, sx: { marginRight: 'spaceXs' } }) }))) : (React.createElement(Base, { sx: {
                paddingX: 'spaceS',
                position: 'relative',
                '[data-genesis-element="FORM_TEXTAREA_CONTAINER"]': {
                    paddingBottom: '50px',
                },
            } },
            React.createElement(FormTextarea, { ref: ref, disabled: disabled, placeholder: placeholder || labels[lang].entrypointInputPlaceholder, rows: 1, autoComplete: "off", value: inputValue, "data-atx-onclick-payload": textBoxClickPayload, maxLength: 1500, onChange: (e) => setInputValue(e.target.value), onKeyUp: (e) => {
                    if (!e || !inputValue.trim().length)
                        return;
                    if (e.key == 'Enter' && !e.shiftKey) {
                        formRef.current?.requestSubmit();
                    }
                }, sx: {
                    resize: 'none',
                    height: 'size90',
                    fontSize: 'fontSizeS',
                    borderColor: 'colorBorderForm',
                    _focusWithin: {
                        borderColor: 'colorBorderActionable',
                    },
                } }),
            React.createElement(Button, { a11yLabel: labels[lang].submitQuestion, variant: "primary", size: "small", iconOnly: React.createElement(ArrowUpIcon, null), type: "submit", disabled: !inputPopulated, sx: {
                    position: 'absolute',
                    bottom: 'spaceM',
                    right: 'spaceL',
                } }))))));
});
Input.displayName = 'AMAInput';
export default Input;
